import { ReactComponent as ChevronUp } from '../../../../../assets/svg/chevron-down.svg';
import { isNumberOrEmpty } from '../../../../../lib/utils';

const COUNT_UNIT = {
  REPS: 'reps',
  SEC: 'sec',
};

const Item = ({
  index,
  exercise,
  openIndex,
  handleSelectExercise,
  handleDeleteExercise,
  selectedExercises,
  setSelectedExercises,
  preference,
}) => {
  const handleOpenExercise = () => {
    if (openIndex === index) {
      handleSelectExercise(null);
    } else {
      handleSelectExercise(index);
    }
  };

  const handleAddSet = () => {
    const newList = [...selectedExercises];
    newList[index].sets.push({ weight: 0, count: 0, unit: COUNT_UNIT.REPS });
    setSelectedExercises(newList);
  };

  const handleDeleteSet = (targetIndex) => {
    const newList = [...selectedExercises];
    newList[index].sets = newList[index].sets.filter(
      (_, i) => i !== targetIndex
    );
    setSelectedExercises(newList);
  };

  const handleChangeCountUnit = (targetIndex) => {
    const newList = [...selectedExercises];
    newList[index].sets[targetIndex].unit =
      newList[index].sets[targetIndex].unit === COUNT_UNIT.REPS
        ? COUNT_UNIT.SEC
        : COUNT_UNIT.REPS;
    setSelectedExercises(newList);
  };

  const handleChangeWeight = (e, i) => {
    if (isNumberOrEmpty(e.target.value)) {
      const newList = [...selectedExercises];
      newList[index].sets[i].weight = e.target.value;
      setSelectedExercises(newList);
    }
  };

  const handleChangeCount = (e, i) => {
    if (isNumberOrEmpty(e.target.value)) {
      const newList = [...selectedExercises];
      newList[index].sets[i].count = e.target.value;
      setSelectedExercises(newList);
    }
  };

  return (
    <div className='mb-2'>
      <div
        className={`text-white flex items-center justify-between bg-tertiary p-2 transition-all ${
          openIndex === index ? 'rounded-t-xl' : 'rounded-xl'
        }`}
      >
        <button
          className='size-6 flex justify-center items-center opacity-50'
          onClick={() => handleDeleteExercise(index)}
        >
          x
        </button>
        <div
          className='flex-1 flex justify-between items-center gap-2'
          onClick={handleOpenExercise}
        >
          <div>{exercise.name}</div>
          <ChevronUp
            className={`text-2xl flex justify-center items-center size-6 rounded-full transition-transform duration-300 ${
              openIndex === index ? 'rotate-180' : 'opacity-50'
            }`}
          />
        </div>
      </div>
      <div
        className={`transition-all ease-in-out duration-450 delay-100 ${
          openIndex === index
            ? 'max-h-64 opacity-100 overflow-y-auto scrollbar-hidden p-2'
            : 'invisible max-h-0 opacity-0 overflow-hidden'
        } divide-y-[1px] divide-tertiary`}
      >
        {exercise.sets.map((set, i) => (
          <div
            className='flex items-center justify-between py-2'
            key={i}
          >
            <div className='flex items-center gap-2'>
              <span
                className='text-white/50 size-5 flex justify-center items-center'
                onClick={() => handleDeleteSet(i)}
              >
                x
              </span>
              <div className='text-white'>set {i + 1}</div>
            </div>
            <div className='text-white flex items-center gap-2'>
              <div>
                <input
                  type='number'
                  value={set.weight}
                  onChange={(e) => handleChangeWeight(e, i)}
                  className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-14 text-center'
                />
              </div>
              <div>{preference.weightUnit.toLowerCase()}</div>
            </div>
            <div className='text-white flex items-center gap-2'>
              <div>
                <input
                  type='number'
                  value={set.count}
                  onChange={(e) => handleChangeCount(e, i)}
                  className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-14 text-center'
                />
              </div>
              <div
                onClick={() => handleChangeCountUnit(i)}
                className='relative inline-flex items-center cursor-pointer w-16 h-6'
              >
                <div
                  className={`absolute w-full h-full rounded-full transition-colors duration-200 ease-in-out flex items-center justify-around px-1 text-xs font-medium bg-secondary`}
                >
                  <span className='text-white'>reps</span>
                  <span className='text-white'>sec</span>
                </div>
                <div
                  className={`absolute h-5 bg-tertiary rounded-full top-0.5 transition-all duration-200 ease-in-out ${
                    set.unit.toLowerCase() === COUNT_UNIT.REPS
                      ? 'translate-x-[34px] w-7'
                      : 'translate-x-0.5 w-8'
                  }`}
                />
              </div>
            </div>
          </div>
        ))}
        <button
          className={`text-white w-full bg-secondary rounded-full py-2 mt-3 ${
            openIndex !== index && 'opacity-0'
          }`}
          onClick={handleAddSet}
        >
          Add Set
        </button>
      </div>
    </div>
  );
};

export default Item;
